// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-pickem-single-entry-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 4px 8px 4px;
}
@media (min-width: 768px) {
  .super-pickem-single-entry-container {
    max-width: 80%;
  }
}

.super-pickem-single-entry-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 450px;
}
@media (min-width: 768px) {
  .super-pickem-single-entry-content {
    max-width: 900px;
  }
}

.super-pickem-single-entry-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  text-align: center;
}
@media (min-width: 768px) {
  .super-pickem-single-entry-column {
    min-width: 80px;
  }
}

.super-pickem-single-entry-header-text.MuiTypography-root {
  font-size: 12px !important;
  font-weight: 700 !important;
  text-decoration: underline;
  width: 100%;
  text-align: center;
}
@media (min-width: 768px) {
  .super-pickem-single-entry-header-text.MuiTypography-root {
    font-size: 24px !important;
  }
}

.super-pickem-single-entry-text.MuiTypography-root {
  font-size: 12px !important;
  font-weight: 700 !important;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
@media (min-width: 768px) {
  .super-pickem-single-entry-text.MuiTypography-root {
    font-size: 24px !important;
    margin-top: 8px;
    height: 24px;
  }
}

.super-pickem-single-entry-champ-box {
  display: flex;
  border-radius: 4px;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (min-width: 768px) {
  .super-pickem-single-entry-champ-box {
    height: 40px;
    width: 40px;
  }
}

.super-pickem-multiple-entry-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  padding-bottom: 8px;
}
@media (min-width: 768px) {
  .super-pickem-multiple-entry-container {
    gap: 100px;
    max-width: 1000px;
    margin: 0 auto;
    justify-content: space-evenly;
  }
}

.super-pickem-multiple-entry-content {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 4px;
}
@media (min-width: 768px) {
  .super-pickem-multiple-entry-content {
    gap: 32px;
    padding: 8px;
  }
}

.super-pickem-multiple-entry-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}
@media (min-width: 768px) {
  .super-pickem-multiple-entry-column {
    min-width: 80px;
  }
}

.super-pickem-multiple-entry-header-text {
  font-size: 12px !important;
  font-weight: 700 !important;
  text-decoration: underline;
  text-align: center;
}
@media (min-width: 768px) {
  .super-pickem-multiple-entry-header-text {
    font-size: 18px !important;
  }
}

.super-pickem-multiple-entry-text {
  font-size: 11px !important;
  font-weight: 700 !important;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .super-pickem-multiple-entry-text {
    font-size: 18px !important;
    margin-top: 8px;
    height: 24px;
  }
}

.super-pickem-multiple-entry-text-small {
  font-size: 9px !important;
  font-weight: 700 !important;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 768px) {
  .super-pickem-multiple-entry-text-small {
    font-size: 18px !important;
    margin-top: 8px;
    height: 24px;
  }
}

.super-pickem-multiple-entry-champ-box {
  display: flex;
  border-radius: 4px;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (min-width: 768px) {
  .super-pickem-multiple-entry-champ-box {
    height: 40px;
    width: 40px;
  }
}

.super-pickem-multiple-entry-champ-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/UserDash/UserDashComponents/SuperPickemGame/SuperPickemUserDashStyles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AACF;AACE;EATF;IAUI,cAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AAEF;AAAE;EAPF;IAQI,gBAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAGF;AADE;EAPF;IAQI,eAAA;EAIF;AACF;;AAAE;EACE,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,WAAA;EACA,kBAAA;AAGJ;AADI;EAPF;IAQI,0BAAA;EAIJ;AACF;;AACE;EACE,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAEJ;AAAI;EATF;IAUI,0BAAA;IACA,eAAA;IACA,YAAA;EAGJ;AACF;;AACA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAEF;AAAE;EATF;IAUI,YAAA;IACA,WAAA;EAGF;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8BAAA;EACA,mBAAA;AACF;AACE;EARF;IASI,UAAA;IACA,iBAAA;IACA,cAAA;IACA,6BAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AAEF;AAAE;EANF;IAOI,SAAA;IACA,YAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAGF;AADE;EANF;IAOI,eAAA;EAIF;AACF;;AADA;EACE,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,kBAAA;AAIF;AAFE;EANF;IAOI,0BAAA;EAKF;AACF;;AAFA;EACE,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAKF;AAHE;EARF;IASI,0BAAA;IACA,eAAA;IACA,YAAA;EAMF;AACF;;AAHA;EACE,yBAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAMF;AAJE;EARF;IASI,0BAAA;IACA,eAAA;IACA,YAAA;EAOF;AACF;;AAJA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAOF;AALE;EATF;IAUI,YAAA;IACA,WAAA;EAQF;AACF;;AALA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAQF","sourcesContent":[".super-pickem-single-entry-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  max-width: 100%; // Changed from 80% to use full width on mobile\n  margin: 0 auto;\n  padding: 0 4px 8px 4px; // Reduced horizontal padding\n\n  @media (min-width: 768px) {\n    max-width: 80%;\n  }\n}\n\n.super-pickem-single-entry-content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; // Changed from space-evenly for tighter spacing\n  width: 100%;\n  max-width: 450px;\n\n  @media (min-width: 768px) {\n    max-width: 900px;\n  }\n}\n\n.super-pickem-single-entry-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 60px; // Reduced from 80px for mobile\n  text-align: center;\n  \n  @media (min-width: 768px) {\n    min-width: 80px;\n  }\n}\n\n.super-pickem-single-entry-header-text {\n  &.MuiTypography-root {\n    font-size: 12px !important; // Reduced from 14px\n    font-weight: 700 !important;\n    text-decoration: underline;\n    width: 100%;\n    text-align: center;\n    \n    @media (min-width: 768px) {\n      font-size: 24px !important;\n    }\n  }\n}\n\n.super-pickem-single-entry-text {\n  &.MuiTypography-root {\n    font-size: 12px !important; // Reduced from 14px\n    font-weight: 700 !important;\n    height: 20px; // Reduced height\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    \n    @media (min-width: 768px) {\n      font-size: 24px !important;\n      margin-top: 8px;\n      height: 24px;\n    }\n  }\n}\n\n.super-pickem-single-entry-champ-box {\n  display: flex;\n  border-radius: 4px;\n  height: 24px;\n  width: 24px;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  @media (min-width: 768px) {\n    height: 40px;\n    width: 40px;\n  }\n}\n\n// Multiple entry styles\n\n.super-pickem-multiple-entry-container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 8px; // Reduced from 16px\n  justify-content: space-between; // Changed from space-evenly\n  padding-bottom: 8px;\n\n  @media (min-width: 768px) {\n    gap: 100px;\n    max-width: 1000px;\n    margin: 0 auto;\n    justify-content: space-evenly;\n  }\n}\n\n.super-pickem-multiple-entry-content {\n  display: flex;\n  justify-content: center;\n  gap: 16px; // Reduced from 32px\n  padding: 4px; // Reduced from 8px\n  \n  @media (min-width: 768px) {\n    gap: 32px;\n    padding: 8px;\n  }\n}\n\n.super-pickem-multiple-entry-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 60px; // Reduced from 80px\n  \n  @media (min-width: 768px) {\n    min-width: 80px;\n  }\n}\n\n.super-pickem-multiple-entry-header-text {\n  font-size: 12px !important; // Reduced from 14px\n  font-weight: 700 !important;\n  text-decoration: underline;\n  text-align: center;\n\n  @media (min-width: 768px) {\n    font-size: 18px !important;\n  }\n}\n\n.super-pickem-multiple-entry-text {\n  font-size: 11px !important; // Reduced from 12px\n  font-weight: 700 !important;\n  height: 20px; // Reduced from 24px\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (min-width: 768px) {\n    font-size: 18px !important;\n    margin-top: 8px;\n    height: 24px;\n  }\n}\n\n.super-pickem-multiple-entry-text-small {\n  font-size: 9px !important; // Reduced from 10px\n  font-weight: 700 !important;\n  height: 20px; // Reduced from 24px\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (min-width: 768px) {\n    font-size: 18px !important;\n    margin-top: 8px;\n    height: 24px;\n  }\n}\n\n.super-pickem-multiple-entry-champ-box {\n  display: flex;\n  border-radius: 4px;\n  height: 24px;\n  width: 24px;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  @media (min-width: 768px) {\n    height: 40px;\n    width: 40px;\n  }\n}\n\n.super-pickem-multiple-entry-champ-logo {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
